const l = (e) => e.replace(/(^(<br>)+)|((<br>)+$)/gm, ""), r = [
  "blockquote",
  "p",
  "em",
  "strong",
  "i",
  "b",
  "br",
  "a",
  "ul",
  "ol",
  "li",
  "img",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "s"
], p = [...r, "div"], c = (e) => e.replace(/<p><br\/><\/p>/g, "<br />"), i = (e) => e.replace(/<style([\s\S]*?)<\/style>/gi, "").replace(/<script([\s\S]*?)<\/script>/gi, "").replace(/<\/div>/gi, `
`).replace(/<\/li>/gi, `
`).replace(/<li>/gi, "  *  ").replace(/<\/ul>/gi, `
`).replace(/<\/p>/gi, `
`).replace(/<br\s*[/]?>/gi, `
`).replace(/<[^>]+>/gi, "");
export {
  r as ALLOWED_COMMENT_TAGS,
  p as ALLOWED_DESCRIPTION_TAGS,
  i as htmlToPlainText,
  c as replaceEmptyParagraphsToBr,
  l as trimBrTagsOnHtml
};
